<template>
  <div>
    <el-form size="small" ref="formData" :model="formData" label-width="150px">
      <el-form-item label="logo" :rules="[{required: true,message: '选择Logo'}]">
        <el-button @click="chooseImg('logo')">选择头像</el-button>
        <div v-if="formData.imageId" class="img m-t-10">
          <img :src="formData.imagePath" width="100" height="100"/>
        </div>
      </el-form-item>
      <el-form-item label="专家姓名">
        <el-input v-model="formData.expertName" placeholder="请输入专家姓名" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="电话号码">
        <el-input v-model="formData.phone" placeholder="请输入电话号码" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="按钮文字">
        <el-input v-model="formData.btnText" placeholder="请输入按钮文字" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="专家简介">
        <el-input class="max-w460" :autosize="{ minRows: 8, maxRows: 8}" resize="none" type="textarea" show-word-limit
                  maxlength="60"
                  v-model="formData.expertDesc"></el-input>
      </el-form-item>
      <el-form-item label="企业微信Url">
        <el-input v-model="formData.wechatServerUrl" placeholder="请输入企业微信Url" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="企业微信corpId">
        <el-input v-model="formData.corpId" placeholder="请输入企业微信corpId" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="是否显示">
        <el-radio-group v-model="formData.isShow">
          <el-radio :label="1">显示</el-radio>
          <el-radio :label="0">隐藏</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="个人微信码">
        <el-button @click="chooseImg('wxCode')">选择个人微信码</el-button>
        <div v-if="formData.wxCodeId" class="img m-t-10">
          <img :src="formData.wxCodePath" width="100" height="100"/>
        </div>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">提交</el-button>
      </div>
    </el-form>

    <!--上传图片-->
    <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc"></Upload>

  </div>
</template>

<script>
import SettingApi from '@/api/setting.js'
import Upload from '../../../components/file/Upload'

export default {
  name: 'Index',
  components: {Upload},
  data () {
    return {
      /*是否在提交*/
      loading: false,
      /*是否打开图片选择*/
      isupload: false,
      /*表单数据对象*/
      formData: {
        imageId: 0,
        expertName: '',
        phone: '',
        expertDesc: '',
        btnText: '立即咨询',
        imagePath: '',
        isShow: 1,
        wxCodeId: 0,
        wxCodePath: '',
        wechatServerUrl: '',
        corpId: '',
      },
      chooseType: ''
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.getData()
    },
    /*获取配置数据*/
    getData () {
      let self = this
      SettingApi.getCustomerService({}, true).then(res => {
        if (res.data != null) {
          self.formData = res.data
          self.userId = res.data.userId
        }
      })
        .catch(error => {

        })
    },
    /*提交*/
    onSubmit () {
      let self = this
      let params = this.formData
      self.$refs.formData.validate((valid) => {
        if (valid) {
          self.loading = true
          SettingApi.setCustomerService(params, true)
            .then(data => {
              self.loading = false
              self.$message({
                message: '恭喜你，保存设置成功',
                type: 'success'
              })
            })
            .catch(error => {
              self.loading = false
            })
        }
      })
    },
    /*选择图片*/
    chooseImg (e) {
      this.chooseType = e
      this.isupload = true
    },

    /*关闭选择图片*/
    returnImgsFunc (e) {
      if (e != null && e.length > 0) {
        if (this.chooseType === 'logo') {
          this.formData.imagePath = e[0].filePath
          this.formData.imageId = e[0].fileId
        } else if (this.chooseType === 'wxCode') {
          this.formData.wxCodePath = e[0].filePath
          this.formData.wxCodeId = e[0].fileId
        }
      }
      this.isupload = false
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/setting/customerservice/index.vue